import type { ForYouConfig } from '@atlassian/global-side-navigation';
import { MENU_ID_FOR_YOU } from '@atlassian/jira-navigation-apps-sidebar-nav4-context/src/common/constants.tsx';
import { jiraHomeRoute } from '@atlassian/jira-router-routes-jira-home-routes/src/jiraHomeRoute.tsx';

export function getForYouConfig(): ForYouConfig {
	return {
		forYouItem: {
			menuItemId: MENU_ID_FOR_YOU,
			url: jiraHomeRoute.path,
		},
	};
}
